// extracted by mini-css-extract-plugin
export default {"section":"Home_section__5lphB"};